<template>
  <div
    class="settings__actions flex justify-end"
    :class="{ 'no-border': noTopBorder }">
    <!-- CANCEL btn -->
    <b-button
      v-if="showCancel"
      :class="{loading: saveBusy}"
      :disabled="saveBusy || !hasChanges"
      class="flex settings__actions--cancel"
      @click="resetChanges">
      <span>Cancel</span>
    </b-button>
    <!-- SAVE btn -->
    <b-button
      variant="primary"
      :class="{loading: saveBusy}"
      :disabled="saveBusy || !formValid || !hasChanges"
      class="flex settings__actions--save"
      @click="saveChanges">
      <span>Save</span>
      <Spinner
        v-if="saveBusy"
        :size="14"
        :thickness="2"
        :color="SBColors.white" />
    </b-button>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import Spinner from '../../../common/Spinner';

export default {
  name: 'FooterActions',
  components: {
    Spinner,
  },
  props: {
    formValid: {
      type: Boolean,
      required: true,
      default: false,
    },
    saveBusy: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true,
    },
    noTopBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      SBColors,
    };
  },
  methods: {
    resetChanges() {
      this.$emit('reset');
    },
    saveChanges() {
      this.$emit('save');
    },
  },
};
</script>

<style lang="scss" scoped>
.no-border {
  border-top: none !important;
  margin-top: 0 !important;
}
</style>
